import { ReactNode, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './Portal.module.scss';
interface PortalProps {
  children: ReactNode;
  elementId: string;
  customStyles: boolean;
}

const PortalModal = ({ children, elementId, customStyles }: PortalProps) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);
  return mounted ? (
    <>
      {createPortal(
        <div className={customStyles ? '' : `${styles['portal-container']}`}>{children}</div>,
        document?.getElementById(elementId) as HTMLElement,
      )}
    </>
  ) : null;
};

export default PortalModal;
